<!--页面部分-->
<template>
  <div class="InterfaceLog">
    <!--数据部分-->
    <div class="centerStructure">
      <!--检索条件-->
      <div class="searchBox">
        <span class="inp">客户名称：</span>
        <el-select filterable v-model="searchForm.operator" placeholder="客户名称">
          <el-option class="wh200"
                     v-for="item in searchForm.operatorOption"
                     :key="item.userId"
                     :label="item.userName"
                     :value="item.userId">
          </el-option>
        </el-select>
        <span class="inp">请求时间：</span>
        <el-date-picker
            v-model="searchForm.dateValue"
            type="datetimerange"
            :default-time="['00:00:00','23:59:59']"
            :clearable="true"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            size="small"
            :picker-options="pickerOptionsDate">
        </el-date-picker>
        <el-button type="primary" @click="searchButton" icon="el-icon-search">查询</el-button>
      </div>
      <!--表格数据-->
      <el-table
          :data="interfaceLogTableData"
          border
          ref="singleTable"
          style="width: 100%"
          height="calc(100% - 84px)">
        <el-table-column fixed header-align="center" type="index" align="center" width="50"></el-table-column>
        <el-table-column prop="operation"
                         label="操作"
                         width="60px"
                         align="center"
                         header-align="center">
          <template slot-scope="scope">
                        <span class="tableicon"><i @click="interfaceLogInfoButton(scope)"
                                                   class="el-icon-view"></i></span>
          </template>
        </el-table-column>

        <template v-for="item in interfaceLogTableTitle">
          <el-table-column
              :align="item.align"
              :header-align="item.halign"
              :key="item.index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :formatter="item.formatter"
              v-if="item.prop !== 'operation'"
              show-overflow-tooltip>
          </el-table-column>
        </template>
      </el-table>
      <!--分页数据-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNumber"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
      </el-pagination>
      <!--弹窗-->
      <el-dialog
          :title="popupTitle"
          :visible.sync="openFlag"
          :close-on-click-modal="false"
          :modal-append-to-body="false"
          width="1020px"
          height="350px"
          @close="closeDialog"
      >
        <div class="formbox">
          <el-form
              :model="interfaceLogForm"
              ref="ruleForm"
              :label-position="labelPosition"
              label-width="100px"
          >
            <el-row>
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="客户名称：" prop="customerName">
                    <el-input class="wh200" v-model="interfaceLogForm.customerName"
                              disabled></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="客户类型：" prop="customerType">
                    <el-input class="wh200" v-model="interfaceLogForm.customerType"
                              disabled></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="请求时间：" prop="clientPort">
                    <el-input class="wh200" v-model="interfaceLogForm.requestTime"
                              disabled></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="状态：" prop="status">
                    <el-radio-group class="wh200" v-model="interfaceLogForm.status"
                                    disabled>
                      <el-radio border label='true'>成功</el-radio>
                      <el-radio border label='false'>失败</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="请求地址：" prop="requestUrl">
                    <el-input style="width: 528px;" v-model="interfaceLogForm.requestUrl"
                              disabled></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row class="textareaUp">
              <el-col :span="24">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="请求内容：">
                    <pre class="content jsonlh">{{interfaceLogForm.requestParams}}</pre>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="返回内容：">
                    <pre class="content return jsonlh">{{interfaceLogForm.responseData}}</pre>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-dialog>
    </div>

  </div>
</template>
<!--JS部分-->
<script>
import {Mixins} from '@/config/mixins/mixins'
import {$http} from '@/config/api/axios'
import SearchDialog from '@/components/custom/Searchdialog'
import SelectTree from "@/components/common/SelectTree";

export default {
  name: "interfaceLog",
  mixins: [Mixins],  //混入公共方法,慎用.
  components: {
    SearchDialog,  //引入高级查询弹窗
    SelectTree, //下拉树
  },

  data() {

    return {
      jsonSelectTree: [],
      isSelectTreeDisabled: false, //是否可编辑
      pickerMinDate1:'',
      pickerMaxDate1:'',
      pickerOptionsDate:{
        onPick:({ maxDate, minDate })=>{
          if(minDate){
            this.pickerMinDate1 = minDate.getTime()
          }
          if (maxDate) {
            this.pickerMinDate1 = ''
            this.pickerMaxDate1 =  maxDate.getTime()
          }
        },
        disabledDate:(time)=>{
          let day60 = (30 - 1) * 24 * 3600 * 1000;
          if (this.pickerMinDate1 !== '') {
            let minTime = this.pickerMinDate1 - day60;
            let maxTime = this.pickerMinDate1 + day60;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return false
        }
      },
      //检索条件
      searchForm: {
        operator: 0,
        operatorOption: [], //操作人下拉框
        startTime: '', //开始时间
        endTime: '', //结束时间
        dateValue:[new Date((+(new Date())) - 3600 * 1000 * 24 * 7), new Date((+(new Date())))], // 供水查询时间
      },
      //接口日志表格数据
      interfaceLogTableData: [],
      //接口日志表头
      interfaceLogTableTitle: [
        {prop: "customerName", label: '客户名称', width: '300px', align: 'left', halign: 'center', show: true,},
        {prop: "customerType", label: '客户类型', width: '120px',align: 'center',  halign: 'center',show: true,},
        {prop: "systemVersion", label: '系统版本', width: '120px',align: 'center',  halign: 'center',show: true,},
        {prop: "requestTime", label: '请求时间', width: '150px', align: 'center', halign: 'center', show: true,},
        {prop: "responseTime", label: '响应时间', width: '160px', align: 'center', halign: 'center', show: true,},
        {prop: "status", label: '状态', width: '100px', align: 'center', halign: 'center', show: true,},
        {prop: "requestUrl", label: '请求地址', width: '', align: 'center', halign: 'center', show: true,},
      ],
      //弹窗部分
      popupTitle: '接口日志信息',
      //窗体打开标志
      openFlag: false,
      //表单域标签的位置，值为 left 或者 right 时，则需要设置 label-width
      labelPosition: 'right',
      //表单
      interfaceLogForm: {
        customerName: '',
        customerType: '',
        requestTime: '',
        status: '',
        requestUrl: '',
        requestParams: '',
        responseData: '',
      },

      //分页数据
      pageSize: 20, //条数
      pageNumber: 1,
      pageTotal: 0, //总页数
    }
  },

  //监听部分
  watch: {},
  //方法部分
  methods: {
    //弹窗取消按钮
    resetForm(ref) {
      this.openFlag = false;
      this.closeDialog();
    },
    //关闭弹窗
    closeDialog() {
      this.$refs['ruleForm'].resetFields(); //清空表单
    },
    //查询按钮
    searchButton() {
      this.handleCurrentChange(1);
    },
    //查询接口日志列表
    getInterfaceLogList() {
      this.interfaceLogTableData = [];
      this.selfLoadingOpen('.InterfaceLog');
      let _this = this;
      if (this.searchForm.dateValue !== "" && this.searchForm.dateValue != null) {
        this.searchForm.startTime = Math.floor(this.searchForm.dateValue[0] / 1000);
        this.searchForm.endTime = Math.ceil(this.searchForm.dateValue[1] / 1000)
      } else {
        this.searchForm.startTime = null;
        this.searchForm.endTime = null;
      }
      let params = {};
      params.pageSize = _this.pageSize;
      params.pageNumber = _this.pageNumber;
      params.customerId = _this.searchForm.operator;
      params.startDate = _this.searchForm.startTime;
      params.endDate = _this.searchForm.endTime;
      $http("get", "interfaceLog/listInterfaceLog", params)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              for (let i = 0; i < res.data.length; i++) {
                this.interfaceLogTableData.push(res.data[i])
              }
              this.pageTotal = res.count;
            } else if (res.status === 'NORESOURCES') {
              this.interfaceLogTableData = [];
              this.pageTotal = 0;
            } else {
              this.msgerror(res.message);
            }
            this.selfLoadingClose();
          });
    },
    //查询客户下拉框
    getOperatorSelect() {
      $http("get", "customerInfo/getAllCustomer")
          .then((res) => {
            if (res.status === 'SUCCESS') {
              for (let i = 0; i < res.data.length; i++) {
                this.searchForm.operatorOption.push(res.data[i]);
              }
              this.searchForm.operatorOption.unshift({"userId": 0, "userName": "全部"});
            } else {
              this.msgerror(res.message);
            }
          })
    },
    //点击详情按钮
    interfaceLogInfoButton(scope) {
      let param = {};
      param.logId = scope.row.id;
      $http("get", "interfaceLog/getInterfaceLogById", param)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              this.interfaceLogForm.customerName = res.data.customerName;
              this.interfaceLogForm.customerType = res.data.customerType;
              this.interfaceLogForm.requestTime = res.data.requestTime;
              this.interfaceLogForm.status = res.data.status;
              this.interfaceLogForm.requestUrl = res.data.requestUrl;
              let str = JSON.parse(res.data.requestParams);
              this.interfaceLogForm.requestParams = JSON.stringify(str, null, 3);
              this.interfaceLogForm.responseData = JSON.stringify(JSON.parse(res.data.responseData), null, 3); ;
              this.openFlag = true; //打开弹窗
            } else {
              this.msgerror(res.message);
            }
          });
    },
    //切换页面方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getInterfaceLogList();
    },
  },
  //初始化页面执行方法
  created: function () {
    this.getInterfaceLogList(); //初始化调用查询接口日志列表方法
    this.getOperatorSelect();
  },
  activated() {
    if (!!this.$refs['singleTable']) {
      this.$refs.singleTable.doLayout();
    }
  },
}
</script>
<!--css部分-->
<style lang="less">
.InterfaceLog {
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;
  position: relative;

  .userAgentWidth {
    width: 520px;
  }

  .userAgentheight {
    height: 250px;
  }

  .content {
    height: 250px;
    overflow: auto;
    width: 853px;
    border: 1px solid #DCDFE6;
    margin: 0;
  }

  .return {
    height: 100px;
  }

  .searchBox {
    display: flex;

    .el-select {
      width:200px;
    }

    .inp {
      line-height: 32px;
    }

    .el-date-editor.el-range-editor {
      width: 355px;
    }
  }
  .textareaUp{
    height: 272px;
    overflow: hidden;
  }
}
</style>